import React from 'react'
import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer>
      <div className="upperfooter">
        <a href="/cityu-hongkong/" className="footer_logo">
          <img src="https://static.igem.wiki/teams/4154/wiki/assets/logo.png" className="logo_footer" alt="horse" />
        </a>
        <div className="contact_us">
          
          <div className="contuct_down">
            <a target="_blank" href="https://www.instagram.com/igem_cityu/" className="contact_us_link">
              follow us
              <br/>
              <br />
              <img src="https://static.igem.wiki/teams/4154/wiki/assets/instagram.svg" alt="" /><br /><br /><span>@igem_cityu</span>
            </a>
            
            <a target="_blank" href="mailto:cityuigem2022@gmail.com" className="contact_us_link">
              contact us
              <br />
              <br />
              <img src="https://static.igem.wiki/teams/4154/wiki/assets/email.svg" alt="" /><br /><br /><span>cityuigem2022@gmail.com</span>
            </a>
            
          </div>
        </div>
        <div className="partners">
          <div className="coloumn">
            <a target="_blank" href="https://www.instagram.com/cuhksbs.igem/"><img src="https://static.igem.wiki/teams/4154/wiki/assets/atreous.png" alt="" /></a>
            
          </div>
          <div className="coloumn">
            <a target="_blank" href="https://www.instagram.com/igemtecchih/"><img src="https://static.igem.wiki/teams/4154/wiki/assets/igem.png" alt="" /></a>

          </div>
          <div className="coloumn">
            <a target="_blank" href="https://www.instagram.com/waterloo.igem/"><img src="https://static.igem.wiki/teams/4154/wiki/assets/water-loo.png" alt="" /></a>

          </div>
        </div>
      </div>
      <div className="footer">
        <div className="project">
          <h2 className="footer_bold">Project</h2>
          <ul>
            <li>
              <NavLink strict exact to="/Engineering">
                Engineering
              </NavLink>
            </li>
            <li>
              <NavLink strict exact to="/Contribution">
                Contribution
              </NavLink>
            </li>
            <li>
              <NavLink strict exact to="/Implementation">
                Implementation
              </NavLink>
            </li>
            <li>
              <NavLink strict exact to="/Entrepreneurship">
                Entrepreneurship
              </NavLink>
            </li>
            
          </ul>
        </div>
        <div className="project">
          <h2 className="footer_bold">Lab</h2>
          <ul>
            <li>
              <NavLink strict exact to="/model">
                Modeling
              </NavLink>
            </li>
            
            <li>
              <NavLink strict exact to="/Experiments">
                Experiments
              </NavLink>
            </li>
            
            <li>
              <NavLink strict exact to="/proof-of-concept">
                Proof of Concept
              </NavLink>
            </li>
            <li>
              <NavLink strict exact to="/results">
                Lab Results
              </NavLink>
            </li>
            
          </ul>
        </div>
        <div className="project">
          <h2 className="footer_bold">Parts</h2>
          <ul>
            <li>
              <NavLink strict exact to="/Parts">
                Parts
              </NavLink>
            </li>
            
            
          </ul>
        </div>
        <div className="project">
          <h2 className="footer_bold">Safety</h2>
          <ul>
            <li>
              <NavLink strict exact to="/Engineering">
                
              </NavLink>
              <a href="">Safety</a>
            </li>

          </ul>
        </div>
        <div className="project">
          <h2 className="footer_bold"> human practices</h2>
          <ul>
            <li>
              <NavLink strict exact to="/integratedhumanpractice">
                integrated human practices
              </NavLink>
            </li>
            
            <li>
              <NavLink strict exact to="/communication">
                Education & Science Communication
              </NavLink>
              <a href=""></a>
            </li>
            <li>
              <NavLink strict exact to="/Collaboration">
                Collaboration
              </NavLink>
            </li>

            <li>
              <NavLink strict exact to="/Partnership">
                Partnership
              </NavLink>
            </li>
            
            <li>
              <NavLink strict exact to="https://2022.igem.wiki/cityu-hongkong/public-survey">
                Public Opinion Survey Analysis
              </NavLink>
            </li>
            <li>
              <NavLink strict exact to="https://2022.igem.wiki/cityu-hongkong/expert-interviews">
                Expert Interviews
              </NavLink>
            </li>
            <li>
              <NavLink strict exact to="https://2022.igem.wiki/cityu-hongkong/urban-mushroom-visit">
                Urban Mushroom interview
              </NavLink>
            </li>
            <li>
              <NavLink strict exact to="https://2022.igem.wiki/cityu-hongkong/comics">
                Comics
              </NavLink>
            </li>

          </ul>
        </div>
        <div className="project">
          <h2 className="footer_bold">team</h2>
          <ul>
            <li>
              <NavLink strict exact to="/Engineering">
                Team Members
              </NavLink>
            </li>
            
            <li>
              <NavLink strict exact to="/Engineering">
                Attributions
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="project">
          <h2 className="footer_bold">team</h2>
          <ul>
            <li>
              <NavLink strict exact to="/Awards">
                Awards
              </NavLink>
            </li>

          </ul>
        </div>
      </div>
    </footer>
  )
}
